import axios from 'axios'
import Swal from 'sweetalert2'
import { supabase } from '@/supabase' // Import the supabase client

const baseURL = 'https://wmknzfufmicidspkwazr.supabase.co/rest/v1'
// const baseURL = 'http://localhost:3000/api'

const axiosInstance = axios.create({
  baseURL
})

axiosInstance.interceptors.request.use(
  config => {
    const session = supabase.auth.session()
    const token = session?.access_token

    console.log('--- API Interceptor Debug ---')
    console.log('Current User (from supabase.auth.user()):', supabase.auth.user())
    console.log('Supabase Session (from supabase.auth.session()):', session)
    console.log('Extracted Access Token:', token)
    console.log('--- End API Interceptor Debug ---')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      console.warn('No access token found for API request.')
    }
    return config
  },
  err => Promise.reject(err)
)

export const apiHelper = axiosInstance

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})
